import React, { Component } from 'react';

export default class LogoZColor extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    componentDidMount() { }

    componentWillReceiveProps() { }

    render() {

        return (

            <svg style={this.props.style} className={this.props.className} xmlns='http://www.w3.org/2000/svg' viewBox='250 250 500 500'>
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stop-color="#00cfbb" />
                        <stop offset="100%" stop-color="#49ca75" />
                    </linearGradient>
                </defs>
                <path stroke="url(#gradient)" xmlns="http://www.w3.org/2000/svg" d="M724,598H502.9l0,0l-32.3,21H703v84v0H302.6l0,0L724,429.5V276H276v126h427v12.6v0L297,678.1v-92.4      L547.7,423h-43.9v0L276,570.8V724h448V598z M297,381v-84v0h406v0v84H297z" />
            </svg>
        );
    }
}